import React from 'react'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
  Box,
} from '@material-ui/core'
import ArrowUpward from '@material-ui/icons/ArrowUpward'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import classnames from 'classnames'
import CountUp from 'react-countup'

import { exportFormatedMoney } from '../../../util/utils'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1),
  },
  differenceValueNegative: {
    color: colors.red[900],
    marginRight: theme.spacing(1),
  },
  noDifference: {
    color: colors.grey[900],
    marginRight: theme.spacing(1),
  },
}))

const LaundryCard = ({ total, tipo, today, isMoney, decimals = 2 }) => {
  const classes = useStyles()

  const contUp = value => {
    return (
      <CountUp
        end={value}
        duration={0.7}
        decimals={decimals}
        decimal=","
        separator="."
      />
    )
  }

  const contUpMoney = money => {
    return (
      <CountUp
        end={money}
        duration={0.7}
        decimals={decimals}
        decimal=","
        prefix="R$"
        separator="."
      />
    )
  }

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              {tipo}
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
              className={classes.differenceValue}
            >
              {isMoney ? contUpMoney(total) : contUp(total)}
            </Typography>
          </Grid>
        </Grid>
        <Box mt={2} display="flex" alignItems="center">
          <ArrowUpward className={classes.differenceIcon} />
          <Typography className={classes.differenceValue} variant="body2">
            {isMoney ? contUpMoney(today) : contUp(today)}
          </Typography>
          <Typography color="textSecondary" variant="caption">
            Hoje
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export default LaundryCard
